import React, { useCallback, useState } from "react";
import SwipeableViews from "react-swipeable-views";
import Pagination from "../Pagination";
import YouTubeVideo from '../event/youtube_video'

const styles = {
  root: {
    padding: '0 60px',
  },
  slideContainer: {
    padding: '0 5px',
  },
  slide: {
    padding: 5,
    minHeight: 100,
    borderRadius: '10px',
  },
  slideContent1: {
    borderRadius: '10px',
  },
  slideContent2: {
    borderRadius: '10px',
    border: 'none',
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  },
};

const mainSlider = ({ photoUrl, videoIds, subPhotoUrls }) => {
  const itemCount = 1 + (videoIds ? videoIds.length : 0) + (subPhotoUrls ? subPhotoUrls.length : 0)
  const [photoIndex, setPhotoIndex] = useState(0);

  const handleChangeIndex = useCallback(
    (i) => {
      setPhotoIndex(i);
    },
    [setPhotoIndex]
  );

  return (
    <React.Fragment>
      <SwipeableViews
        enableMouseEvents
        index={photoIndex}
        onChangeIndex={(i) => handleChangeIndex(i)}
        style={styles.root}
        slideStyle={styles.slideContainer}
      >
          <figure className="adjust-box adjust-box-3x2 mb-0" style={styles.slide}>
            <img
              data-src={photoUrl}
              alt="EventImage"
              className="adjust-box-inner lazyload w-100 object-fit-cover"
              style={styles.slideContent1}
            />
          </figure>
          {videoIds && videoIds.length > 0 &&
            videoIds.map((id, idx) => (
            <figure key={idx} className="adjust-box adjust-box-3x2 mb-0" style={styles.slide}>
              <YouTubeVideo id={id} uniqId={idx} style={styles.slideContent2}/>
            </figure>
          ))}
          {subPhotoUrls && subPhotoUrls.length > 0 &&
            subPhotoUrls.map((url, idx) => (
            <figure key={idx} className="adjust-box adjust-box-3x2 mb-0" style={styles.slide}>
              <img
                data-src={url}
                alt="EventSubImage"
                className="adjust-box-inner lazyload w-100 object-fit-cover"
                style={styles.slideContent1}
              />
            </figure>
          ))}
      </SwipeableViews>
      <Pagination
        dots={itemCount}
        index={photoIndex}
        onChangeIndex={(i) => handleChangeIndex(i)}
        />
    </React.Fragment>
  );
};

export default mainSlider;